import { AuxiliumComponent } from "../auxilium-component";

export class ListItem extends AuxiliumComponent {
	parsedCallback() {
		if (this.closest("chip-list")?.hasAttribute("clickable")) {
			this.appendChild(document.createElementWithContents("chip-button", this.childNodes, {
				variation: "body",
				className: "list--button"
			}));
		}
	}
}